import { useEffect, useState } from "react";
import { list } from "@/lib/api";

export function useEventOptions() {
  const [options, setOptions] = useState([]);
  const [events, setEvents] = useState([]);
  useEffect(() => {
    list("events").then((d) => {
      setEvents(d);
      setOptions(d.map((e) => ({ value: e.id, label: `${e.groom} & ${e.bride}` })));
    }).catch(() => {});
  }, []);
  return { options, events };
}

export function useOptions(resource, labelFn) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    list(resource).then((d) => setOptions(d.map((x) => ({ value: x.id, label: labelFn(x) })))).catch(() => {});
  }, [resource]); // eslint-disable-line
  return options;
}
